"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _drinkCardRefund = require("@/api/basic/drinkCardRefund");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'drinkCardRefund',
  data: function data() {
    return {
      loading: false,
      activeTab: 'all',
      searchForm: {
        refundStatus: null,
        refundType: null,
        page: 1,
        limit: 20
      },
      tableData: [],
      total: 0
    };
  },
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    parseTime: _utils.parseTime,
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _drinkCardRefund.getDrinkCardRefundPage)(this.searchForm).then(function (res) {
        _this.tableData = res.list || [];
        _this.total = res.total || 0;
      }).catch(function () {
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleTabChange: function handleTabChange() {
      this.searchForm.refundStatus = this.activeTab === 'all' ? null : Number(this.activeTab);
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleFilter: function handleFilter() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.activeTab = 'all';
      this.searchForm = {
        refundStatus: null,
        refundType: null,
        page: 1,
        limit: 20
      };
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    refundTypeText: function refundTypeText(t) {
      return {
        1: '自动到期',
        2: '手动退款'
      }[t] || '-';
    },
    refundStatusText: function refundStatusText(s) {
      return {
        0: '处理中',
        1: '已退款',
        2: '退款失败',
        3: '无需退款'
      }[s] || '-';
    },
    refundStatusTagType: function refundStatusTagType(s) {
      return {
        0: 'info',
        1: 'success',
        2: 'danger',
        3: ''
      }[s] || 'info';
    }
  }
};